module.exports = __webpack_public_path__ + "img/Desktop_Carousel3.08553f52.png";